<template>
  <div>
    <el-card>
      <el-dialog
        class="dialog_size"      
        title="选择部门"
        :visible.sync="dialogVisible1"
        :before-close="handleClose"
      >
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-aside width="90%">
                <el-input
                  style="margin-bottom:12px"
                  size="small"
                  placeholder="输入关键字进行过滤"
                  v-model="filterText"
                ></el-input>
                <el-tree
                  class="filter-tree"
                  
                  :data="data"
                  v-loading="loading"
                  :props="defaultProps"
                  node-key="id"
                  :filter-node-method="filterNode"
                  ref="tree"
                >
                  <span class="custom-tree-node" slot-scope="{ node }">
                    <span style="font-size:14px;height:40px;">{{ node.label }}</span>
                  </span>
                </el-tree>
              </el-aside>
            </div>
          </el-col>
           <el-col :span="5">
            <div class="grid-content bg-purple-light">
                  <el-select v-model="DutyId" clearable filterable @change="selectGetDuty" placeholder="请选择岗位">
                  <el-option v-for="v in duty" :label="v.ClassName" :key="v.Id" :value="v.Id"></el-option>
                  </el-select>
              
            </div>
          </el-col>


           <el-col :span="5">
            <div class="grid-content bg-purple-light">
                  <el-select v-model="PositionId" clearable filterable @change="selectGetPosition" placeholder="请选择职务">
                  <el-option v-for="v in positionArray" :label="v.ClassName" :key="v.Id" :value="v.Id"></el-option>
                  </el-select>
              
            </div>
          </el-col>


          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              生效时间：
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="EffectTime"
                style="width: 50%;"
              ></el-date-picker>
            </div>
          </el-col>
        </el-row>

        <el-button size="small" type="primary" @click="initMoveDepartment">确定</el-button>
      </el-dialog>
      <el-dialog
        class="dialog_size"
        title="离职"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="离职时间" required>
            <el-form-item prop="LeaveDate">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="ruleForm.LeaveDate"
                style="width: 70%;"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>
          <el-form-item label="离职一级原因" prop="LeaveMainReasonID">
            <el-select
              v-model="ruleForm.LeaveMainReasonID"
              clearable
              placeholder="请选择离职一级原因"
              style="width: 70%;"
              @change="bindMainReasonID"
            >
              <el-option v-for="v in options" :key="v.Id" :label="v.ClassName" :value="v.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="离职二级原因" prop="LeaveReasonID">
            <el-select
              v-model="ruleForm.LeaveReasonID"
              clearable
              placeholder="请选择离职二级原因"
              style="width: 70%;"
              @change="bindLeaveReasonID"
            >
              <el-option v-for="v in options2" :key="v.Id" :label="v.ClassName" :value="v.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="离职深层原因" prop="LeaveDeepReason">
            <el-input v-model="ruleForm.LeaveDeepReason"></el-input>
          </el-form-item>
          <el-form-item label="离职建议" prop="LeaveSuggest">
            <el-input v-model="ruleForm.LeaveSuggest"></el-input>
          </el-form-item>
          <el-form-item label="再次入职意愿" prop="EntryAgain">
            <el-select v-model="ruleForm.EntryAgain" placeholder="请选择" style="width: 70%;">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否跟进" prop="IsFollow">
            <el-select v-model="ruleForm.IsFollow" placeholder="请选择" style="width: 70%;">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保险停办日期" required>
            <el-form-item prop="IsuranceEndDate">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="ruleForm.IsuranceEndDate"
                style="width: 70%;"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>
          <el-form-item label="备注" prop="Note">
            <el-input v-model="ruleForm.Note"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button size="small" @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>在职管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-container style="height: 100%; ">
        <el-aside width="15%" v-if="this.widthElAside > 0.5">
          <el-input
            style="margin-bottom:12px"
            size="small"
            placeholder="输入关键字进行过滤"
            v-model="filterText"
          ></el-input>
          <el-tree
            class="filter-tree"
            :data="data"
            v-loading="loading"
            :props="defaultProps"
            :default-expand-all="false"
            node-key="id"
            @node-click="handleNodeClick"
            :filter-node-method="filterNode"
            ref="tree"
          >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span style="font-size:14px;height:40px;">{{ node.label }}</span>
            </span>
          </el-tree>
        </el-aside>
        <el-container>
          <el-header style="height:20px">
            <el-row style="padding-top:0px">
              <el-col :span="24">
                <el-form v-model="searchName" :inline="true" class="demo-form-inline">
                  <el-form-item style="float:left">
                    <el-button size="small" type="primary" plain @click="HiddenOrShow" >{{buttonHiddenShowText}}</el-button>
                  </el-form-item>
                             <el-form-item style="float:right">
                    <el-button size="small" icon="el-icon-search" @click="SearchByName">查询</el-button>
                  </el-form-item>
                  <el-form-item style="float:right">
                    <el-input size="small" clearable v-model="searchName" placeholder="请输入姓名或部门"></el-input>
                  </el-form-item>
       
                  <el-form-item style="float:right">
                    <el-button size="small" type="success" @click="HistoryToExcel" plain>导出历史轨迹</el-button>
                  </el-form-item>
                  <el-form-item style="float:right">
                    <el-button
                      size="small"
                      type="danger"
                      @click="dialogVisible1 = true"
                      plain
                    >批量移动部门</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-header>
          <el-main>
            <el-table
              :data="userAllInfo"
              ref="multipleTable"
              style="width: 100%;height:100%"
              v-loading="loading"
              size="small"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="SysUser.UserCode" label="工号"></el-table-column>
              <el-table-column prop="SysUser.TrueName" label="姓名"></el-table-column>
              <el-table-column prop="SysUser.MainDeptsName" label="部门">
                <template slot-scope="scope">
                  <div>
                    <el-popover trigger="hover" placement="top">
                      <el-steps
                        :space="200"
                        :active="1"
                        finish-status="success"
                      >{{ scope.row.SysUser.FullPath }}</el-steps>
                      <div slot="reference" class="name-wrapper">
                        <span>{{ scope.row.SysUser.MainDeptsName }}</span>
                      </div>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="SysUser.PositionName" label="职务"></el-table-column>
              <el-table-column prop="SysUser.DutyType" label="岗位类别"></el-table-column>
              <el-table-column prop="SysUser.Duty" label="岗位"></el-table-column>
              <el-table-column prop="UserBaseInfo.RankName" label="薪级"></el-table-column>
              <el-table-column prop="UserBaseInfo.LevelName" label="薪档"></el-table-column>
              <el-table-column prop="UserBaseInfo.SalaryDate" label="计薪时间"></el-table-column>
              <el-table-column prop="UserBaseInfo.IsRegular" :formatter="IsRegular" label="是否转正"></el-table-column>
              <el-table-column prop="SysUser.Status" :formatter="Status" label="状态"></el-table-column>
              <el-table-column label="操作" width="260">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="bindUserInfo(scope.row)">查看</el-button>
                  <el-button size="small" type="text" @click="editUserInfo(scope.row)">编辑档案</el-button>
                  <el-popover placement="right" width="1400" trigger="click">
                    <el-table :data="gridLogData" style="width: 100%">
                      <el-table-column type="expand">
                        <template slot-scope="props">
                          <el-table :data="props.row.Zeus_LogDetails">
                            <el-table-column width="200" property="Name" label="标题"></el-table-column>
                            <el-table-column width="250" property="OldValue" label="旧值"></el-table-column>
                            <el-table-column width="200" property="NewValue" label="新值"></el-table-column>
                          </el-table>
                        </template>
                      </el-table-column>
                      <el-table-column label="记录标题" prop="LogTitle"></el-table-column>
                      <el-table-column label="操作人" prop="OperatorName"></el-table-column>
                      <el-table-column label="操作类型" prop="OperateType"></el-table-column>
                      <el-table-column label="记录类型" prop="LogType"></el-table-column>
                      <el-table-column label="操作IP" prop="OperatorIP"></el-table-column>
                      <el-table-column label="日志时间" prop="LogTime"></el-table-column>
                    </el-table>
                    <el-button
                      size="small"
                      type="text"
                      slot="reference"
                      @click="GetLogList(scope.row)"
                      plain
                    >人员异动</el-button>
                  </el-popover>
                  <el-popover placement="right" width="980" trigger="click">
                    <el-table :data="gridHistoryData">
                      <el-table-column width="160" property="EntryTime" label="生效时间"></el-table-column>
                      <el-table-column width="50" property="OperateType" label="类型"></el-table-column>
                      <el-table-column width="450" property="FarmePath" label="部门"></el-table-column>
                      <el-table-column width="100" property="Duty" label="岗位"></el-table-column>
                      <el-table-column width="100" property="SalaryType" label="薪级体系"></el-table-column>
                      <el-table-column width="60" property="RankName" label="薪级"></el-table-column>
                      <el-table-column width="60" property="LevelName" label="薪档"></el-table-column>
                    </el-table>
                    <el-button
                      size="small"
                      type="text"
                      slot="reference"
                      @click="GetHistoryList(scope.row)"
                      plain
                    >历史轨迹</el-button>
                  </el-popover>
                  <el-button size="small" type="text" @click="dialogVisibleYang(scope.row)" plain>离职</el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-row>
              <el-col style="text-align:right;margin-top:6px;" :span="24">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageIndex"
                  :page-sizes="pageSizes"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalCount"
                  style="float:right"
                ></el-pagination>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
    </el-card>
  </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { getUrlKey } from "../../until/ZeusApiSDK/Logic/ImageStr";
import { GetSysItemListByParentID } from "../../until/ZeusApiSDK/Logic/SysItemLogic";
import {
  MoveDepentmentThirdParty,
  UserThirdPartyRecordAdd,
  MoveDepartment,
  UserMoveDepartmentAdd,
  GetHistoryExportToExcel,
  RemoveUser,
  GetLogList,
  GetHistoryList,
  GetOnJobSysUserPageList,
  GetUserCode,
  InsertUserInfo
} from "../../until/ZeusApiSDK/Logic/SysUserLogic";
import {
  GetGuid,
  GetCurrentUserInfo
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { PostProxyByUrl } from "../../until/ZeusApiSDK/ZeusAPIClient";
import { EnqueueUserLeave } from "../../until/ZeusApiSDK/Logic/LogLogic";
import {
  GetItem,
  GetFrameTreeList,
  GetFrameTreeListByPer
} from "../../until/ZeusApiSDK/Logic/Frame";
export default {
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    return {
      positionArray:[
                  {Id:'100',ClassName:'CEO'},
                  {Id:'101',ClassName:'副总'},
                  {Id:'102',ClassName:'总经理'},
                  {Id:'103',ClassName:'总监'},
                  {Id:'104',ClassName:'大区经理'},
                  {Id:'105',ClassName:'经理'},
                  {Id:'106',ClassName:'行业经理'},
                  {Id:'107',ClassName:'见习经理'},
                  {Id:'108',ClassName:'储备经理'},
                  {Id:'109',ClassName:'主管'},
                  {Id:'110',ClassName:'专员'},
         ],//职务
      duty:[],//岗位
      DutyId:'',//岗位id 
      PositionId:'',//职务id    
      EffectTime: "", //生效时间  "5a7eafb2-0b31-46cc-93db-bd97ab0fd1ae","ba7508ec-3ad7-40b8-a3a4-eb01bd63098a",
      expandedKeys: [
        "5a7eafb2-0b31-46cc-93db-bd97ab0fd1ae",
        "ba7508ec-3ad7-40b8-a3a4-eb01bd63098a"
      ], //树节点展示节点
      options: [], //离职一级原因下拉内容
      options2: [], //离职二级原因下拉内容
      dialogVisible: false,     
      dialogVisible1: false,
      userMoveDepartment: {   
        ID: "",
        UserID: "",
        OldMainDeptsName: "",
        OldMainDeptsID: "",
        MainDeptsName: "",
        MainDeptsID: "",
        OperateUserId: "",
        OperateUserName: "",
        EffectTime: "",
        OperateTime: "",

      }, //保存用户移动部门信息
      UserThirdPartyRecord: {
        ID: "",
        UserID: "",
        MainDeptsName: "",
        MainDeptsID: "",
        OperateUserId: "",
        OperateUserName: "",
        OperateTime: "",
        Note: "",
        Type: ""
      }, //保存用户(企业微信，邮箱)移动部门信息
      ViewChangeDepartment: {
        CompanyID: "",
        CompanyName: "",
        CenterID: "",
        CenterName: "",
        GroupID: "",
        GroupName: "",
        MainDeptsName: "",
        MainDeptsID: "",
        UserIds: [],
        DutyId:"",//调动岗位id
        Duty:'',//岗位
        PositionId:'',//员工职务编号
        PositionName:'',//员工职务名称
        OperateUserId: "",//操作人id
        OperateUserName: "",//操作人名字
        EffectTime: "",//生效时间

      }, //保存用户移动部门信息
      ruleForm: {
        Id: "",
        UserID: "",
        LeaveDate: "",
        LeaveMainReasonID: "",
        LeaveReasonID: "",
        LeaveDeepReason: "",
        LeaveSuggest: "",
        EntryAgain: "",
        IsFollow: "",
        IsuranceEndDate: "",
        Note: ""
      },
      rules: {
        LeaveMainReasonID: [
          { required: true, message: "请选择离职原因", trigger: "change" }
        ],
        LeaveDate: [
          {
            type: "date",
            required: true,
            message: "请选择离职日期",
            trigger: "change"
          }
        ]
      },
      gridLogData: [],
      gridHistoryData: [],
      id: "", //节点树部门id
      widthElAside: 20, //测边框宽度
      userAllInfo: [], //数据信息
      searchName: "", //搜索信息
      name: "", //
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      currentUser: {}, //当前登录用户信息
      currentRole: {}, //当前用户角色
      type: [], //薪资体系
      dutyType: [], //岗位类别
      filterText: "",
      duty: [], //岗位
      ranks: [], //薪级
      levels: [], //薪档
      loading: true, //是否加载中
      data: [], //树状节点
      imageUrl: "", //上传图片路径地址
      defaultProps: {
        children: "children",
        label: "label",
        disabled: "type"
      },
      buttonHiddenShowText:"隐藏组织架构"
    };
  },
  methods: {
          //选择岗位
            selectGetDuty:async function(vId){
                let obj = {};
                obj = await this.duty.find((item)=>{//这里的userList就是上面遍历的数据源
                    if(item.Id == vId){
                        this.ViewChangeDepartment.Duty=item.ClassName;
                    }
                });
            },


        //选择职务
          selectGetPosition:async function(vId){
                let obj = {};
                obj = await this.positionArray.find((item)=>{//这里的userList就是上面遍历的数据源
                    if(item.Id == vId){
                        this.ViewChangeDepartment.PositionName=item.ClassName;
                    }
                });
            },


    open() {
      this.$alert("请选择需要移动部门的人员", "提示", {
        confirmButtonText: "确定"
      });
    },
    NewGuid: function guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
     //离职按钮
    dialogVisibleYang:function(data){
      this.dialogVisible=true;
      this.ruleForm.UserID=data.SysUser.Id;
    },
    //离职提交
    RemoveUser: async function() {
      //转换离职时间  时间格式
      if (this.ruleForm.LeaveDate != "" && this.ruleForm.LeaveDate != null) {
        const leave = new Date(this.ruleForm.LeaveDate);
        const leaveDate =
          leave.getFullYear() +
          "-" +
          this.p(leave.getMonth() + 1) +
          "-" +
          this.p(leave.getDate());
        this.ruleForm.LeaveDate = leaveDate;
      }
      //转换保险停办期时间  时间格式
      if (
        this.ruleForm.IsuranceEndDate != "" &&
        this.ruleForm.IsuranceEndDate != null
      ) {
        const isuranceEnd = new Date(this.ruleForm.IsuranceEndDate);
        const isuranceEndDate =
          isuranceEnd.getFullYear() +
          "-" +
          this.p(isuranceEnd.getMonth() + 1) +
          "-" +
          this.p(isuranceEnd.getDate());
        this.ruleForm.IsuranceEndDate = isuranceEndDate;
      }
      this.ruleForm.ID = this.NewGuid();
      this.ruleForm.UserID = this.ruleForm.UserID;
      console.log('this.ruleForm',this.ruleForm);
      //添加数据
      await RemoveUser(this.ruleForm).then(res => {
        if (res == "success") {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          //添加日志
          this.addLog(this.ruleForm);
        } else {
          this.$message.error(res);
        }
      });
    },
    //获取一级原因下拉
    bindMainReasonID: async function(vId) {
      let obj = {};
      obj = await this.options.find(item => {
        //这里的options就是上面遍历的数据源
        if (item.Id == vId) {
          this.ruleForm.LeaveMainReasonID = item.Id;
          GetItem(this.ruleForm.LeaveMainReasonID.toString()).then(res => {
            this.options2 = res;
          });
        }
      });
    },
    bindLeaveReasonID: async function(vId) {
      //这里的options2就是上面遍历的数据源
      let obj = {};
      obj = await this.options2.find(item => {
        //这里的options就是上面遍历的数据源
        if (item.Id == vId) {
          this.ruleForm.LeaveReasonID = item.Id;
        }
      });
    },
    //获取人员异动数据
    GetLogList: function(data) {
      GetLogList(data.SysUser.Id).then(res => {
        this.gridLogData = res.data;
      });
    },
    //获取历史轨迹数据
    GetHistoryList: function(data) {
      GetHistoryList(data.SysUser.Id).then(res => {
        this.gridHistoryData = res.data;
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
        
          this.$router.push(
        "/SysUser/UserManage"
      );
          done();        
        })
        .catch(_ => {});
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //保存数据库离职信息
          this.RemoveUser();
          //alert("保存成功");
        } else {
          alert("保存失败!!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //查看用户信息
    bindUserInfo: function(data) {
      this.$router.push(
        "/SysUser/UserInfo?UserID=" + data.SysUser.Id + "&name=在职管理"
      );
    },
    //编辑用户信息
    editUserInfo: function(data) {
      this.$router.push(
        "/SysUser/EditUserInfo?UserID=" + data.SysUser.Id + "&name=在职管理"
      );
    },
   
    HiddenOrShow: function() {
      if (this.widthElAside == 0) {
        this.buttonHiddenShowText="隐藏组织架构"
        this.widthElAside = 20;
      } else {
        this.buttonHiddenShowText="显示组织架构"
        this.widthElAside = 0;
      }
    },
    //导出历史轨迹Excel
    HistoryToExcel: function() {
       this.loading=true;
      GetHistoryExportToExcel().then(res => {       
        if (res != null) {
          window.open("http://hr.ruizhiqi.com/" + res);
        }
         this.loading=false;
      });
    },
    //批量移动部门
    initMoveDepartment: function() {
      if (this.$refs.tree.getCurrentNode() == null) {
        alert("请选择要移动到的部门");
         return;
      } 
      if (!this.$refs.multipleTable.selection.length > 0) {
          this.open();
           return;
        } //拿到人员id进行人员部门移动
      if (this.EffectTime == null || this.EffectTime == "") {
            alert("请选择生效时间");
            return;
          }
        else {
          //todo       
          this.ViewChangeDepartment.MainDeptsID = this.$refs.tree.getCurrentNode().Id;
          this.ViewChangeDepartment.MainDeptsName = this.$refs.tree.getCurrentNode().label;
          this.ViewChangeDepartment.DutyId=this.DutyId;//岗位id
          this.ViewChangeDepartment.PositionId=this.PositionId;//职务id
          var userArray = this.$refs.multipleTable.selection; 
          if (userArray <= 0) {
            this.$message({
              type: "error",
              message: "请选择操作项"
            });
            return false;
          }
          this.loading = true;
          var ids="";
          userArray.forEach(item => {
            if(item!=""&&item!="undefined")
            {
              ids += item.SysUser.Id + ",";
            }
            
          });
           if (this.EffectTime != "" && this.EffectTime != null) {
              const effect = new Date(this.EffectTime);
              const effectDate =
                effect.getFullYear() +
                "-" +
                this.p(effect.getMonth() + 1) +
                "-" +
                this.p(effect.getDate());
              this.ViewChangeDepartment.EffectTime = effectDate;
            }
          this.ViewChangeDepartment.UserIds = ids.split(",");
         this.ViewChangeDepartment.OperateUserName = this.currentUser.TrueName;
         this.ViewChangeDepartment.OperateUserId = this.currentUser.UserId;
          //1移动部门表
          var data = this.ViewChangeDepartment;
          
          MoveDepartment(data).then(res => {
            if (res.Message == "调动成功") {
             this.$message({
                    message: '调动成功',
                    type: 'success'
              });
              this.dialogVisible1 = false;
              this.GetOnJobSysUserPageList();
            } else if (res.Message == "调动失败") {
             this.$message.error('调动失败');
              this.dialogVisible1 = false;
              this.GetOnJobSysUserPageList();
              
            } else {
              alert(res.Message);
              this.dialogVisible1 = false;
              this.GetOnJobSysUserPageList();
            }
          });






          // //移动企业微信和企业邮箱组织架构
          // //2保存记录
          // for (let item of this.ViewChangeDepartment.UserIds) {
          //   //（一）循环每个人的id去调动部门添加记录
          //   //转换移动部门生效时间  时间格式
          //   if (this.EffectTime != "" && this.EffectTime != null) {
          //     const effect = new Date(this.EffectTime);
          //     const effectDate =
          //       effect.getFullYear() +
          //       "-" +
          //       this.p(effect.getMonth() + 1) +
          //       "-" +
          //       this.p(effect.getDate());
          //     this.userMoveDepartment.EffectTime = effectDate;
          //   }
          //   this.userMoveDepartment.UserId = item;
          //   this.userMoveDepartment.OperateUserId = this.currentUser.UserId;
          //   this.userMoveDepartment.OperateUserName = this.currentUser.TrueName;
          //   this.userMoveDepartment.MainDeptsName = this.ViewChangeDepartment.MainDeptsName;
          //   this.userMoveDepartment.MainDeptsID = this.ViewChangeDepartment.MainDeptsID;
          //   if (
          //     this.userMoveDepartment.UserId != null &&
          //     this.userMoveDepartment.UserId != ""
          //   ) {
          //     //（二）循环每个人的id去调动部门（企业微信和邮箱）并添加记录
          //     MoveDepentmentThirdParty(item).then(res => {
          //       if (res == "success") {
          //         //添加一下记录
          //         UserThirdPartyRecordAdd(this.UserThirdPartyRecord).then(
          //           res => {
          //             if (res == "success") {
          //               alert("移动部门数据记录成功");
          //               this.dialogVisible1 = false;
          //               this.GetOnJobSysUserPageList();
          //             } else if (res == "fail") {
          //               alert("移动部门数据记录失败");
          //             } else {
          //               alert(res);
          //               this.dialogVisible1 = false;
          //             }
          //           }
          //         );
          //       }
          //     });
          //     UserMoveDepartmentAdd(this.userMoveDepartment).then(res => {
          //       if (res == "success") {
          //         alert("移动部门数据记录成功");
          //         this.dialogVisible1 = false;
          //         this.GetOnJobSysUserPageList();
          //       } else if (res == "fail") {
          //         alert("移动部门数据记录失败");
          //       } else {
          //         alert(res);
          //         this.dialogVisible1 = false;
          //       }
          //     });
          //   }
          // }




        }
      
    },  
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetOnJobSysUserPageList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetOnJobSysUserPageList();
    },
    SearchByName: function() {
      this.pageIndex = 1;
      this.GetOnJobSysUserPageList();
    },
    GetOnJobSysUserPageList: function() {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      GetOnJobSysUserPageList(
        this.currentUser.UserId,
        this.currentRole.Key,
        this.currentUser.FrameId,
        this.currentRole.OtherFrameID,
        this.searchName == "" ? null : this.searchName,
        this.currentRole.DataAuth,
        this.pageIndex,
        this.pageSize,
        this.id
      ).then(res => {
        this.loading = false;
        this.userAllInfo = res.List;
        this.totalCount = res.TotalCount;
      });
    },
    //保险状态
    IsRegular(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "是";
      } else {
        return "否";
      }
    },
     //保险状态
    Status(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "在职";
      } 
      else if(cellValue == 0)
      {
        return "未完善";
      }
       else if(cellValue == 2)
      {
        return "请假";
      }
       else if(cellValue == 3)
      {
        return "出访";
      }
       else if(cellValue == 4)
      {
        return "调休";
      }
       else if(cellValue == 5)
      {
        return "初次审核通过";
      }
       else if(cellValue == 6)
      {
        return "招聘组提交";
      }
       else if(cellValue == -1)
      {
        return "离职";
      }
       else if(cellValue == -2)
      {
        return "初次审核驳回";
      }
       else if(cellValue == -3)
      {
        return "二次审核驳回";
      }
     
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //获取离职原因
    GetItem: function() {
      GetItem("5").then(res => {
        this.options = res;
      });

       //获取岗位
        GetSysItemListByParentID('8').then(res=>{
           this.duty=res;
       });
    },
    //获取当前用户
    getCurrentUser: function() {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取当前用户角色
    getCurrentRole: function() {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    //获取部门树
    GetFrameTree: async function() {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      GetFrameTreeListByPer(
        this.currentUser.UserId,
        this.currentRole.Key,
        this.currentUser.FrameId,
        this.currentRole.OtherFrameID,
        this.searchName == "" ? null : this.searchName,
        this.currentRole.DataAuth,
        //"606",
        this.pageIndex,
        this.pageSize
      ).then(res => {
        this.loading = false;
        this.data = JSON.parse(res);
      });
    },
    //部门树节点点击
    handleNodeClick: function(data) {
      this.id = data.Id;
      this.GetOnJobSysUserPageList();
    },

    p(s) {
      return s < 10 ? "0" + s : s;
    },

    //添加日志
    addLog: function(model) {
      //部门调动成功，添加日志
      EnqueueUserLeave(
        "离职",
        this.currentUser.UserId,
        this.currentUser.TrueName,
        "离职",
        "离职申请提交成功",
        model.UserId,
        model,
        null,
        "userInfoLeave"
      );
    }
  },
  //页面进入加载事件
  created: function() {
    //获取下拉数据
    this.GetItem();
    //获取当前用户
    this.getCurrentUser();
    //获取当前用户角色
    this.getCurrentRole();
    //获取部门树状结构信息
    this.GetFrameTree();
  }
};
</script>
<style lang="less" scoped>
.font_left {
  text-align: left;
}
.font_right {
  text-align: right;
}
.img_size {
  width: 100%;
  // padding:20px;
}
.img_size_80 {
  width: 60%;
  // padding:20px;
}
.div_name {
  font-size: 30px;
  margin-right: 30px;
}
.mar_top_10 {
  margin-top: 10px;
}
.mar_top_20 {
  margin-top: 20px;
}
.mar_left_10 {
  margin-right: 10px;
}
.border_bottom {
  margin-top: 26px;
  border-bottom: 1px dotted #d9d9d9;
}
.height_50 {
  height: 50px;
}
.height_45 {
  height: 45px;
}
//图片上传样式开始 .avatar-uploader
.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
//图片上传样式结束
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.el-input--small .el-input__inner {
  height: 42px;
}
</style>
<style lang="less" scoped>
/deep/.el-form-item__content
{
  line-height: unset !important;
}
</style>
